import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="bg-navy-800 text-white py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-73">
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-slate-700/50 hidden md:block z-0" data-id="element-74"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-77">
            ¿Cómo funciona?
          </h2>
          <p className="text-xl text-slate-300" data-id="element-78">Un proceso simple de 3 pasos</p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-12 md:space-y-24" data-id="element-79">
          {/* Step 1 */}
          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center md:justify-between gap-8" data-id="element-80">
            <div className="md:w-1/2 md:text-right md:pr-12 order-2 md:order-1" data-id="element-81">
              <h3 className="text-2xl font-bold text-gold mb-3" data-id="element-82">
                Identificas el Problema
              </h3>
              <p className="text-lg text-slate-300" data-id="element-83">
                Usas mi método para encontrar qué solución digital necesitan los
                latinos en tu área hoy mismo.
              </p>
            </div>
            <div className="shrink-0 w-16 h-16 rounded-full bg-gold text-navy-900 text-2xl font-bold flex items-center justify-center shadow-[0_0_30px_rgba(212,160,23,0.3)] order-1 md:order-2 z-10" data-id="element-84">
              1
            </div>
            <div className="md:w-1/2 md:pl-12 order-3 hidden md:block" data-id="element-85"></div>
          </motion.div>

          {/* Step 2 */}
          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center md:justify-between gap-8" data-id="element-86">
            <div className="md:w-1/2 md:pr-12 order-3 md:order-1 hidden md:block" data-id="element-87"></div>
            <div className="shrink-0 w-16 h-16 rounded-full bg-gold text-navy-900 text-2xl font-bold flex items-center justify-center shadow-[0_0_30px_rgba(212,160,23,0.3)] order-1 md:order-2 z-10" data-id="element-88">
              2
            </div>
            <div className="md:w-1/2 md:text-left md:pl-12 order-2 md:order-3" data-id="element-89">
              <h3 className="text-2xl font-bold text-gold mb-3" data-id="element-90">
                Montas tu Máquina
              </h3>
              <p className="text-lg text-slate-300" data-id="element-91">
                Sigues las instrucciones paso a paso para activar tu tienda
                Shopify sin complicaciones.
              </p>
            </div>
          </motion.div>

          {/* Step 3 */}
          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center md:justify-between gap-8" data-id="element-92">
            <div className="md:w-1/2 md:text-right md:pr-12 order-2 md:order-1" data-id="element-93">
              <h3 className="text-2xl font-bold text-gold mb-3" data-id="element-94">
                Enciendes el Tráfico
              </h3>
              <p className="text-lg text-slate-300" data-id="element-95">
                Activas anuncios simples en Facebook e Instagram y dejas que el
                sistema venda por ti mientras duermes.
              </p>
            </div>
            <div className="shrink-0 w-16 h-16 rounded-full bg-gold text-navy-900 text-2xl font-bold flex items-center justify-center shadow-[0_0_30px_rgba(212,160,23,0.3)] order-1 md:order-2 z-10" data-id="element-96">
              3
            </div>
            <div className="md:w-1/2 md:pl-12 order-3 hidden md:block" data-id="element-97"></div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}